import { render, staticRenderFns } from "./CLPTopxList.vue?vue&type=template&id=7c347cd3"
import script from "./CLPTopxList.vue?vue&type=script&lang=js"
export * from "./CLPTopxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports